module.exports = __webpack_public_path__ + "static/media/intro.4387e848.mp3";